import React from "react";
import { toast } from "sonner";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";

export function CuponesList({ coupons, authAxios, onRefresh }) {
  const toggle = async (id) => {
    try {
      await authAxios.patch(`/marketing/coupons/${id}/toggle`);
      onRefresh();
    } catch {
      toast.error("Erro ao atualizar cupom");
    }
  };

  const del = async (id) => {
    try {
      await authAxios.delete(`/marketing/coupons/${id}`);
      onRefresh();
      toast.success("Cupom removido");
    } catch {
      toast.error("Erro ao remover cupom");
    }
  };

  return (
    <div className="space-y-2 pt-4 border-t">
      <h3 className="text-sm font-semibold">Gerenciar Cupons</h3>
      {coupons.map(c => (
        <div key={c.id} className="flex items-center justify-between p-3 bg-card border border-border rounded-lg">
          <div className="flex items-center gap-3 flex-1">
            <Badge className="font-mono text-sm px-3 bg-primary/10 text-primary">
              {c.code}
            </Badge>
            <div className="text-xs text-muted-foreground">
              {c.discount_value}{c.discount_type === "percentage" ? "%" : "€"} • {c.uses || 0} usos
            </div>
          </div>
          <div className="flex items-center gap-2">
            <Switch checked={c.active} onCheckedChange={() => toggle(c.id)} />
            <Button
              variant="ghost"
              size="sm"
              onClick={() => del(c.id)}
              className="text-red-500 hover:text-red-700 h-8 w-8 p-0"
            >
              ✕
            </Button>
          </div>
        </div>
      ))}
    </div>
  );
}
